export default "__VITE_ASSET__CH5XzryR__"